import {createNavigationContainerRef} from '@react-navigation/native';
import {NavigationRef} from './types';

const navigationRef: NavigationRef = createNavigationContainerRef();

export default navigationRef;
